import routes from '@/modules/complaint/complaint-routes';
import store from '@/modules/complaint/complaint-store';

export default {
  routes,
  store,
};
